import React, { useState, useEffect } from "react";
import styled from "styled-components";

// Components
import Sidebar from "../Sidebar/Sidebar";
import Map from "../Map/Map";

// Functions
import { sumBy } from "lodash";
import { getForestDonations } from "../../Functions/api";
import { getTreesPlanted } from "../../Functions/functions";

const StyledMainBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  min-height: 81vh;

  &:first-child {
    width: 80vw;
  }
  &:last-child {
    width: 10vw;
    min-width: 150px;
  }
  position: relative;
`;

const MainBody = (props) => {
  useEffect(() => {
    const totalTreesPlanted = getTreesPlanted(
      parseInt(props.totalDonations) + parseInt(props.payment)
    );
    props.setTreesPlanted(Math.round(totalTreesPlanted));
  }, [props.totalDonations, props.payment]);

  useEffect(() => {
    if (props.totalDonations === null) {
      getForestDonations().then((forestDonations) => {
        props.setForestDonations(forestDonations);
        const totalDonated = sumBy(forestDonations, (donation) => Number(donation.donationAmount));
        props.setTotalDonations(totalDonated);
      });
    }
  }, []);

  return (
    <StyledMainBody>
      <Map
        forestLat={props.forestLat}
        forestLng={props.forestLng}
        setForestLat={props.setForestLat}
        setForestLng={props.setForestLng}
        forestDonations={props.forestDonations}
        payment={props.payment}
      />
      <Sidebar
        totalDonations={props.totalDonations}
        payment={props.payment}
        setPayment={props.setPayment}
        forestLat={props.forestLat}
        setForestLat={props.setForestLat}
        forestLng={props.forestLng}
        setForestLng={props.setForestLng}
        treesPlanted={props.treesPlanted}
      />
    </StyledMainBody>
  );
};

export default MainBody;
